import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiply'
})
export class MultiplyPipe implements PipeTransform {
  transform(input: number, factor = 1) {
    return input == null ? null : input * factor;
  }
}
